import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { VoiceCallInterface } from '../components/voice/VoiceCallInterface';
import ChatLayout from '../components/chat/layout/ChatLayout';
import { ChatInterfaceProvider } from '../contexts/ChatInterfaceContext';

const VoiceChat: React.FC = () => {
  const { positId } = useParams<{ positId: string }>();
  const navigate = useNavigate();

  const handleEndCall = () => {
    navigate(`/chat/${positId}`);
  };

  if (!positId) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="text-red-600 text-lg mb-4">Invalid Posit ID</div>
        <button 
          onClick={() => navigate('/')} 
          className="px-6 py-3 bg-primary text-primary-foreground rounded-[var(--radius)] hover:bg-primary/90 transition-colors"
        >
          Go Home
        </button>
      </div>
    );
  }

  return (
    <ChatInterfaceProvider>
      <ChatLayout 
        mobileTitle="Voice Chat"
        showMobileHeader={false}
      >
        <VoiceCallInterface 
          positId={positId} 
          onEndCall={handleEndCall}
        />
      </ChatLayout>
    </ChatInterfaceProvider>
  );
};

export default VoiceChat; 